import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';


import { cleanEntity } from '../shared/util/entity-utils/entity-utils';
import { createEntitySlice, serializeAxiosError } from '../shared/reducers/reducer.utils';


const initialState = {
  loading: false,
  errorMessage: null,
  entities: [],
  proveedores: [],
  servicios: [],
  entity: {},
  updating: false,
  totalItems: 0,
  updateSuccess: false,
} as any;

const apiUrl = 'api/empresas';

// Actions

export const getEntities = createAsyncThunk(
  'empresa/fetch_entity_list',
  async ({ page, size, sort, filters }: any) => {


    const params = new URLSearchParams();

    filters?.forEach((e: any) => {
      params.append(e.filterName, String(e.filterValue));
    });

    // agregar paginación y sort
    params.append("page", String(page));
    params.append("size", String(size));
    params.append("sort", sort);

    const filtersObject = Object.fromEntries(
      filters.map((e: any) => [e.filterName, e.filterValue])
    );



    console.log(`query ${params}`);

    const requestUrl = `${apiUrl}?${params}&cacheBuster=${new Date().getTime()}`;
    return axios.get<any[]>(requestUrl);
  },
  { serializeError: serializeAxiosError },
);

export const getEntity = createAsyncThunk(
  'empresa/fetch_entity',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/${id}`;
    return axios.get<any>(requestUrl);
  },
  { serializeError: serializeAxiosError },
);

export const getProveedores = createAsyncThunk(
  'empresa/fetch_proveedores',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/${id}/proveedor`;
    return axios.get<any>(requestUrl);
  },
  { serializeError: serializeAxiosError },
);

export const getServicios = createAsyncThunk(
  'empresa/fetch_servicios',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/${id}/servicios`;
    return axios.get<any>(requestUrl);
  },
  { serializeError: serializeAxiosError },
);

export const createEntity = createAsyncThunk(
  'empresa/create_entity',
  async (entity: any, thunkAPI) => {
    const result = await axios.post<any>(apiUrl, cleanEntity(entity));
    thunkAPI.dispatch(getEntities({}));
    return result;
  },
  { serializeError: serializeAxiosError },
);

export const updateEntity = createAsyncThunk(
  'empresa/update_entity',
  async (entity: any, thunkAPI) => {
    const result = await axios.put<any>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    thunkAPI.dispatch(getEntities({}));
    return result;
  },
  { serializeError: serializeAxiosError },
);

export const partialUpdateEntity = createAsyncThunk(
  'empresa/partial_update_entity',
  async (entity: any, thunkAPI) => {
    const result = await axios.patch<any>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    thunkAPI.dispatch(getEntities({}));
    return result;
  },
  { serializeError: serializeAxiosError },
);

export const deleteEntity = createAsyncThunk(
  'empresa/delete_entity',
  async (id: string | number, thunkAPI) => {
    const requestUrl = `${apiUrl}/${id}`;
    const result = await axios.delete<any>(requestUrl);
    thunkAPI.dispatch(getEntities({}));
    return result;
  },
  { serializeError: serializeAxiosError },
);

// slice

export const EmpresaSlice = createEntitySlice({
  name: 'empresa',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getEntity.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addCase(deleteEntity.fulfilled, state => {
        state.updating = false;
        state.updateSuccess = true;
        state.entity = {};
      })
      .addMatcher(isFulfilled(getEntities), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          loading: false,
          entities: data,
          totalItems: parseInt(headers['x-total-count'], 10),
        };
      })
      .addMatcher(isFulfilled(getProveedores), (state, action) => {
        const { data, headers } = action.payload;
        return {
          ...state,
          loading: false,
          proveedores: data
        };
      })
      .addMatcher(isFulfilled(getServicios), (state, action) => {
        const { data, headers } = action.payload;
        return {
          ...state,
          loading: false,
          servicios: data
        };
      })
      .addMatcher(isFulfilled(createEntity, updateEntity, partialUpdateEntity), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
        state.entity = action.payload.data;
      })
      .addMatcher(isPending(getEntities, getEntity, getProveedores, getServicios), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })

      .addMatcher(isPending(createEntity, updateEntity, partialUpdateEntity, deleteEntity), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = EmpresaSlice.actions;

// Reducer
export default EmpresaSlice.reducer;
